export default __webpack_public_path__ + "static/media/ic_busd_40.f2392c6a.svg";